module.exports = __webpack_public_path__ + "static/media/POLIESTER-NYLON-Min.f196a757.jpg";